import firebase from "../firebaseConfig";
import React, { useState, useEffect } from "react";
import { Dropdown, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FiUser, FiChevronDown } from 'react-icons/fi';
import "../styles/DashboardNavbar.css";
import useProfilePicture from "../hooks/useProfilePicture";

const DashBoardNavBar = ({ userName, boldItem, isAdminView, exitAdminView }) => {
    const navigate = useNavigate();
    const [currentUserData, setCurrentUserData] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                setCurrentUser(user);
                try {
                    const docRef = firebase.firestore().collection('users').doc(user.uid);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        setCurrentUserData(docSnapshot.data());
                    }
                } catch (error) {
                    console.error('Error fetching user data in navbar:', error);
                }
            } else {
                setCurrentUser(null);
                setCurrentUserData(null);
            }
        });

        return () => unsubscribe();
    }, []);

    // Utiliser le hook personnalisé pour récupérer la photo de profil
    const { profilePicture: displayProfilePicture } = useProfilePicture(currentUser?.uid);
    
    // Utiliser les données passées en props ou les données récupérées automatiquement
    const displayUserName = userName || currentUserData?.username || currentUser?.displayName || currentUser?.email;

    const handleLogout = async () => {
        try {
            await firebase.auth().signOut();
            navigate('/');
        } catch (error) {
            // Handle logout errors
        }
    };

    return (
        <nav className="navbar navbar-light navbar-expand-lg bg-light navigation-clean p-2">
            <div className="container mainContainer">
                <a className="navbar-brand" href="/overview">
                    <img src="img.png" alt="logoOFD" width={"50"}/>
                </a>
                {isAdminView && (
                    <div className="admin-view-badge">
                        <span className="badge bg-warning text-dark">Admin View Mode</span>
                        <button 
                            className="btn btn-sm btn-danger ms-2"
                            onClick={exitAdminView}
                        >
                            Exit
                        </button>
                    </div>
                )}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navcol-1"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navcol-1">
                    <ul className="navbar-nav ml-auto">
                        {/* Tracking */}
                        <NavDropdown 
                            title="TRACKING" 
                            id="tracking-dropdown"
                            className={`nav-dropdown ${['dashboard', 'flowTracker'].includes(boldItem) ? 'fw-bold' : ''}`}
                        >
                            <NavDropdown.Item 
                                href="/flow-state-habits"
                                className={boldItem === 'dashboard' ? 'fw-bold' : ''}
                            >
                                Flow State Habits
                            </NavDropdown.Item>
                            <NavDropdown.Item 
                                href="/flowtracker"
                                className={boldItem === 'flowTracker' ? 'fw-bold' : ''}
                            >
                                Flow Tracker
                            </NavDropdown.Item>
                        </NavDropdown>

                        {/* Personal Development */}
                        <NavDropdown 
                            title="PERSONAL DEVELOPMENT" 
                            id="development-dropdown"
                            className={`nav-dropdown ${['cycles', 'experiences', 'positiveAffirmations'].includes(boldItem) ? 'fw-bold' : ''}`}
                        >
                            <NavDropdown.Item 
                                href="/cycles"
                                className={boldItem === 'cycles' ? 'fw-bold' : ''}
                            >
                                Cycles
                            </NavDropdown.Item>
                            <NavDropdown.Item 
                                href="/experiences"
                                className={boldItem === 'experiences' ? 'fw-bold' : ''}
                            >
                                Experiences
                            </NavDropdown.Item>
                            <NavDropdown.Item 
                                href="/PositiveAffirmations"
                                className={boldItem === 'positiveAffirmations' ? 'fw-bold' : ''}
                            >
                                Positive Affirmations & Journaling
                            </NavDropdown.Item>
                        </NavDropdown>

                        {/* Learning & Support */}
                        <NavDropdown 
                            title="LEARNING & SUPPORT" 
                            id="learning-dropdown"
                            className={`nav-dropdown ${['tutorials', 'personalTraining'].includes(boldItem) ? 'fw-bold' : ''}`}
                        >
                            <NavDropdown.Item 
                                href="/Tutorials"
                                className={boldItem === 'tutorials' ? 'fw-bold' : ''}
                            >
                                Tutorials
                            </NavDropdown.Item>
                            <NavDropdown.Item 
                                href="/personalTraining"
                                className={boldItem === 'personalTraining' ? 'fw-bold' : ''}
                            >
                                Personal Training
                            </NavDropdown.Item>
                        </NavDropdown>

                        {/* Feedback */}
                        <li className={`nav-item ${boldItem === 'feedback' ? 'fw-bold' : ''}`}>
                            <a className="nav-link" href="/feedback">
                                FEEDBACK
                            </a>
                        </li>
                    </ul>
                    <Dropdown align="end" className="ms-auto">
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" className="profile-dropdown-toggle">
                            <div className="profile-dropdown-content">
                                {displayProfilePicture ? (
                                    <img 
                                        src={displayProfilePicture} 
                                        alt="Photo de profil" 
                                        className="navbar-profile-picture"
                                    />
                                ) : (
                                    <div className="navbar-profile-placeholder">
                                        <FiUser size={20} />
                                    </div>
                                )}
                                <span className="navbar-username">{displayUserName}</span>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => navigate('/account')}>My Account</Dropdown.Item>
                            {currentUserData?.isAdmin && (
                                <Dropdown.Item onClick={() => navigate('/adminPanel')}>Admin Panel</Dropdown.Item>
                            )}
                            <Dropdown.Item onClick={handleLogout}>Disconnect</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </nav>
    );
};

export default DashBoardNavBar;
